import {LeaderOwnerModel} from  '../models/leaderowner.model';
export class LeadersModel{
    public domain:string;
    public domainOwner:Array<LeaderOwnerModel>;
    constructor(domain:string,domainOwner:Array<LeaderOwnerModel>){
        this.domain=domain;
        this.domainOwner=domainOwner;
    }

}